import React, { createContext, useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';

const CompareContext = createContext();

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within CompareProvider');
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);
  const MAX_COMPARE = 4;

  useEffect(() => {
    const saved = localStorage.getItem('compareList');
    if (saved) {
      setCompareList(JSON.parse(saved));
    }
  }, []);

  const addToCompare = (product) => {
    if (compareList.length >= MAX_COMPARE) {
      toast.error(`You can compare maximum ${MAX_COMPARE} products`);
      return;
    }

    const exists = compareList.find(item => item._id === product._id);
    if (exists) {
      toast.info('Already in comparison');
      return;
    }

    const newList = [...compareList, product];
    setCompareList(newList);
    localStorage.setItem('compareList', JSON.stringify(newList));
    toast.success('Added to comparison');
  };

  const removeFromCompare = (productId) => {
    const newList = compareList.filter(item => item._id !== productId);
    setCompareList(newList);
    localStorage.setItem('compareList', JSON.stringify(newList));
    toast.success('Removed from comparison');
  };

  const isInCompare = (productId) => {
    return compareList.some(item => item._id === productId);
  };

  const clearCompare = () => {
    setCompareList([]);
    localStorage.removeItem('compareList');
  };

  return (
    <CompareContext.Provider
      value={{
        compareList,
        addToCompare,
        removeFromCompare,
        isInCompare,
        clearCompare,
        compareCount: compareList.length
      }}
    >
      {children}
    </CompareContext.Provider>
  );
};
